import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AosService {

  baseURL = environment.aosBackEndURL + '/api';
  
  constructor(private http: HttpClient) { }

  async LoginPartnerUser() {
    var body = {_Email: environment.partnerUser}
    await this.http.post(this.baseURL + '/users/LoginFromLandingPage', body).toPromise().then((response: any) => {
      this.SaveToken(response.token);
    });
  }
  SaveToken(token) {
    sessionStorage.setItem('aos_value', btoa(token));
  }
  FetchCountries() {
    return this.http.get(this.baseURL + '/users/locations', {headers: new HttpHeaders({'AOS': 'AOS'})});
  }
  FetchInstallationCategories() {
    return this.http.get(this.baseURL + '/partners/GetInstallationTypes', {headers: new HttpHeaders({'AOS': 'AOS'})});
  }
  CreatePartnerFromLandingPage(data) {
    return this.http.post(this.baseURL + '/PartnerManageDistributors/CreatePartnerFromLandingPage', data, {headers: new HttpHeaders({'AOS': 'AOS'})});
  }
  
}
